import classNames from "classnames";
import { Immutable } from "immer";
import React from "react";
import { getGlobalSpacingClasses } from "tsi-common-react/src/components/_spacing/globalSpacing";
import { t } from "ttag";

import type { OprahBlock as OprahBlockValue } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { OprahTitle } from "../OprahTitle";

import styles from "./index.module.scss";

type IProps = Immutable<{ value: OprahBlockValue }>;

export const OprahBlock = (props: IProps): React.JSX.Element => {
    return (
        <article
            className={classNames(
                styles.oprahModulePdp,
                "stitch-bg--light",
                getGlobalSpacingClasses(props.value.spacing),
            )}
        >
            <div className="main-container">
                <img
                    src={props.value.image?.url}
                    alt={t`Cocoon by Sealy Offer`}
                    className={concatClassNames([
                        styles.oprahModulePdpImage,
                        "responsive",
                    ])}
                    loading="lazy"
                    decoding="async"
                />
                <div className={styles.oprahModulePdpInfo}>
                    <OprahTitle>Oprah Loves Us!</OprahTitle>
                    <div className={styles.oprahModulePdpCopy}>
                        {t`For over 20 years, Oprah has been selecting the best of the best for her coveted Favorite Things list. And this year, we’re excited to be named her favorite mattress of 2016.`}
                    </div>
                </div>
            </div>
        </article>
    );
};
